<ng-container *ngIf="!areBuildingsLoading">
  <mat-nav-list>
    <a
      style="height: auto;"
      mat-list-item
      [routerLink]="buildingActions.building.guid"
      *ngFor="let buildingActions of buildingActionsList"
      mdbWavesEffect
    >
      <img
        [src]="getCover(buildingActions.building)"
        alt="{{ buildingActions.building.label }}"
        width="77"
        class="img-thumbnail"
      />
      <div>
        <p class="title">{{ buildingActions.building.label }}</p>
        <div style="display: flex">
          <i class="fas fa-map-marker gray mr-2 w-14"></i>
          <div class="gray-text">
            <p style="margin: 0">
              {{ buildingActions.building.address.houseNumber }}
              {{ buildingActions.building.address.houseNumberExtenstion }}
              {{ buildingActions.building.address.street }}
            </p>
            <p>
              {{ buildingActions.building.address.city }}
            </p>
          </div>
        </div>
      </div>
      <div class="building-icons">
        <i *ngIf="doesBuildingHaveJobsWithHighPriority(buildingActions)" class="fas fa-exclamation" [ngClass]="doesBuildingHaveUrgentJobs(buildingActions) ? 'icon-red' : 'icon-grey'"></i>
        <i *ngIf="doesBuildingHaveJobs(buildingActions)" class="fas fa-wrench icon"></i>
      </div>

      <mat-divider></mat-divider>
    </a>
  </mat-nav-list>
</ng-container>
<app-card-spinner [show]="areBuildingsLoading"></app-card-spinner>
